import React from 'react';
import { useTranslation } from 'react-i18next';

import type { SalesPromotionContactDto } from '@/services/ws-funnel/src/main/resources/rest-api';

export enum MailStatus {
  Sent = 'sent',
  Bounced = 'bounced',
  None = 'none',
}

// NOTE: Translating using hook (instead of just using a map) to be able to track translations' usage
export const useTranslatedMailStatusLabels = (): Record<MailStatus, string> => {
  const { t } = useTranslation(['backend', 'common', 'serviceDashboard']);
  return React.useMemo(
    () => ({
      [MailStatus.Sent]: t('serviceDashboard:SENT'),
      [MailStatus.Bounced]: t('serviceDashboard:MAIL_BOUNCED'),
      [MailStatus.None]: t('common:NO_DATA'),
    }),
    [t],
  );
};

export const getContactMailStatus = (contact: SalesPromotionContactDto): MailStatus => {
  if (contact.isBounced) {
    return MailStatus.Bounced;
  }
  if (contact.mailingTime) {
    return MailStatus.Sent;
  }
  return MailStatus.None;
};
